import React, { Fragment } from "react";

const MainLogo = ({ width, height, size, fill }) => {
  return (
    <Fragment>
      <svg
        viewBox="324.826 101.928 158.495 179.292"
        xmlns="http://www.w3.org/2000/svg"
        width={width || 24}
        height={height || 24}
        size={size || 26}
      >
        <path
          d="M376.159 131.935q2.139-1.218 4.278 0l49.194 28.005q2.139 1.218 2.139 3.653v56.01q0 2.436-2.139 3.653l-49.194 28.005q-2.139 1.218-4.278 0l-49.194-28.005q-2.139-1.217-2.139-3.653v-56.01q0-2.435 2.139-3.653z"
          fill={fill || "rgba(26,237,96,.38)"}
        ></path>
        <path
          d="M427.71 161.285q2.139-1.218 4.278 0l49.194 28.005q2.139 1.218 2.139 3.653v56.01q0 2.436-2.139 3.653l-49.194 28.005q-2.139 1.218-4.278 0l-49.194-28.005q-2.139-1.217-2.139-3.653v-56.01q0-2.435 2.139-3.653z"
          fill={fill || "rgba(50,237,184,.53)"}
        ></path>
        <path
          d="M427.534 102.537q2.139-1.218 4.278 0l49.194 28.005q2.139 1.218 2.139 3.653v56.01q0 2.435-2.139 3.653l-49.194 28.005q-2.139 1.218-4.278 0l-49.194-28.005q-2.139-1.217-2.139-3.653v-56.01q0-2.436 2.139-3.653z"
          fill={fill || "rgba(77,227,107,.62)"}
        ></path>
      </svg>
    </Fragment>
  );
};

export default MainLogo;
